export const DEFAULT_VOCABULARY = {
  'turma.nome_singular': 'Turma',
  'turma.nome_plural': 'Turmas',
  'turma.titulo_novo': 'Nova Turma',
  'turma.titulo_editar': 'Editar Turma',
  'turma.confirmar_exclusao': 'Deseja excluir esta turma?',

  'unidade.nome_singular': 'Unidade',
  'unidade.nome_plural': 'Unidades',
  'unidade.titulo_novo': 'Nova Unidade',
  'unidade.titulo_editar': 'Editar Unidade',
  'unidade.confirmar_exclusao': 'Deseja excluir esta unidade?',

  'equipe.professor_singular': 'Professor',
  'equipe.professor_plural': 'Professores',
  'equipe.professor_titulo_novo': 'Novo Professor',
  'equipe.professor_titulo_editar': 'Editar Professor',
  'equipe.membro_botao_novo': 'Novo Membro',
  'equipe.membro_titulo_novo': 'Novo Membro da Equipe',
  'equipe.membro_titulo_editar': 'Editar Membro da Equipe',
  'equipe.membro_confirmar_exclusao': 'Deseja excluir este membro da equipe?',
  'equipe.membro_msg_sucesso_criar': 'Membro da equipe criado com sucesso',
  'equipe.membro_msg_sucesso_editar': 'Membro da equipe atualizado com sucesso',
  'equipe.membro_msg_sucesso_excluir': 'Membro da equipe excluído com sucesso',
  'equipe.membro_msg_erro_generico': 'Erro ao salvar membro da equipe',
  'equipe.membro_msg_erro_excluir': 'Erro ao excluir membro da equipe',

  'modalidade.nome_singular': 'Modalidade',
  'modalidade.nome_plural': 'Modalidades',
  'modalidade.titulo_novo': 'Nova Modalidade',
  'modalidade.titulo_editar': 'Editar Modalidade',
  'modalidade.confirmar_exclusao': 'Deseja excluir esta modalidade?',
  'modalidade.label_nome': 'Nome da Modalidade',
  'modalidade.msg_sucesso_criar': 'Modalidade criada com sucesso',
  'modalidade.msg_sucesso_editar': 'Modalidade atualizada com sucesso',
  'modalidade.msg_sucesso_excluir': 'Modalidade excluída com sucesso',
  'modalidade.msg_erro_generico': 'Erro ao salvar modalidade',
  'modalidade.msg_erro_excluir': 'Erro ao excluir modalidade',

  'serie.nome_singular': 'Série',
  'serie.nome_plural': 'Séries',
  'serie.titulo_novo': 'Nova Série',
  'serie.titulo_editar': 'Editar Série',
  'serie.confirmar_exclusao': 'Tem certeza que deseja deletar esta série?',
  'serie.label_nome': 'Nome da Série',
  'serie.msg_sucesso_criar': 'Série criada com sucesso',
  'serie.msg_sucesso_editar': 'Série atualizada com sucesso',
  'serie.msg_sucesso_excluir': 'Série deletada com sucesso',
  'serie.msg_erro_generico': 'Erro ao salvar série',
  'serie.msg_erro_excluir': 'Erro ao deletar série',

  'receita.titulo_pagina': 'Receitas',
  'fatura.titulo_pagina': 'Faturas',
  'contrato.titulo_pagina': 'Contratos',
};

export default DEFAULT_VOCABULARY;
